import React from 'react';

import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
	CoreChartOptions,
	DatasetChartOptions,
	ElementChartOptions,
	PluginChartOptions,
	ScaleChartOptions,
	BarControllerChartOptions,
	ChartData,
	ChartType,
	DefaultDataPoint,
} from 'chart.js';
import { _DeepPartialObject } from 'chart.js/dist/types/utils.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
);

type TType = ChartType;
type TData = DefaultDataPoint<TType>;
type TLabel = unknown;

interface IBarChartProps {
	options?: _DeepPartialObject<
		CoreChartOptions<'bar'> &
			ElementChartOptions<'bar'> &
			PluginChartOptions<'bar'> &
			DatasetChartOptions<'bar'> &
			ScaleChartOptions<'bar'> &
			BarControllerChartOptions
	>;
	data: ChartData<'bar', TData, TLabel>;
}

const BarChart: React.FunctionComponent<IBarChartProps> = ({
	options = {},
	data,
}) => <Bar options={options} data={data} />;

export default BarChart;
